import { render, staticRenderFns } from "./newReports.vue?vue&type=template&id=327fdada&scoped=true&"
import script from "./newReports.vue?vue&type=script&lang=js&"
export * from "./newReports.vue?vue&type=script&lang=js&"
import style0 from "./newReports.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newReports.vue?vue&type=style&index=1&id=327fdada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327fdada",
  null
  
)

export default component.exports